<nz-cascader [nzOptions]="unitTreeNodes" [(ngModel)]="unitCascaderValue" [nzShowSearch]="true" [nzAllowClear]="false"
    (nzClear)="onUnitCascaderClear()" (ngModelChange)="onUnitCascaderValueChange()">
</nz-cascader>